<template lang="html">
  <section class="section columns is-primary is-bold mobile-app">
    <div class="column details">
      <div class="box is-floating has-text-centered">
        <h2 class="title is-size-2">Mobile App</h2>
        <h4 class="subtitle is-size-4">RED is available as a mobile app.</h4>
        <app-store-buttons />
      </div>
    </div>
    <div class="column mobile-app-preview">
      <img
        src="https://red.callcw.com/assets/img/prev/mobile-cropped.png"
        alt="Mobile App Preview"
        class="mobile-app-preview"
      />
    </div>
  </section>
</template>

<script>
import AppStoreButtons from '@/components/blocks/AppStoreButtons';

export default {
  name: 'cw-mobile-app-links',
  components: { AppStoreButtons },
};
</script>

<style lang="stylus" scoped>

.section.is-primary.is-bold {
  background-image: url("../../assets/red_metal.png");
  background-repeat: repeat;
}

.mobile-app {
  background: #eb212e
  padding-bottom: 0
  margin: 0
  align-items: center
  .column.mobile-app-preview {
    padding-bottom: 0
    overflow: hidden
    img.mobile-app-preview {
      margin-bottom: -10px
    }

    @media (max-width:800px) {
      width: 300px
      margin: auto
      img.mobile-app-preview {
        margin-bottom: -70px
      }
    }
    @media (min-width: 1000px) {
      max-width: 500px
      margin-right: auto
    }
  }

  .details{
    .box{
      margin: auto
      max-width: 420px
      .store-links {
        .store-badge {
          width: 100%
          max-width: 180px
        }
      }
    }
    @media (min-width: 1000px) {
      max-width: 500px
      margin-left: auto
    }
  }
}
</style>
